// @ts-nocheck
import { useState } from 'react';
import {
  TransformWrapper,
  TransformComponent,
  useControls,
  useTransformEffect,
} from 'react-zoom-pan-pinch';
import { useTheme } from '@mui/material/styles';

const ZoomOutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    aria-hidden="true"
    focusable="false"
    className="yarl__icon"
  >
    <g fill="currentColor">
      <path d="M0 0h24v24H0z" fill="none"></path>
      <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"></path>
    </g>
  </svg>
);

const ZoomInIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    aria-hidden="true"
    focusable="false"
    className="yarl__icon"
  >
    <g fill="currentColor">
      <path d="M0 0h24v24H0z" fill="none"></path>
      <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
      <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"></path>
    </g>
  </svg>
);

const ZoomControls = ({ color }: { color: string }) => {
  const { zoomIn, zoomOut, resetTransform } = useControls();
  const [zoomLevel, setZoomLevel] = useState(1);

  useTransformEffect(({ state }) => {
    setZoomLevel(state.scale);
  });

  const isMinZoom = zoomLevel <= 1.01;
  const isMaxZoom = zoomLevel >= 2.99;

  return (
    <div
      style={{
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        fontWeight: 700,
        fontSize: '20px',
        padding: '8px',
        bottom: 'auto',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 100,
        top: '0',
      }}
    >
      <button
        type="button"
        title="Zoom out"
        aria-label="Zoom out"
        className="yarl__button"
        style={{
          color: isMinZoom ? 'gray' : color,
          backgroundColor: 'transparent',
          boxShadow: 'none',
          textShadow: 'none',
          filter: 'none',
          borderRadius: 0,
          cursor: isMinZoom ? 'default' : 'pointer',
        }}
        onClick={() => zoomOut()}
        disabled={isMinZoom}
      >
        <ZoomOutIcon />
      </button>

      <button
        type="button"
        aria-label="Reset zoom"
        className="yarl__button"
        style={{
          cursor: 'pointer',
          minWidth: '60px',
          textAlign: 'center',
          color,
          backgroundColor: 'transparent',
          boxShadow: 'none',
          textShadow: 'none',
          filter: 'none',
          borderRadius: 0,
        }}
        onClick={() => resetTransform()}
      >
        {Math.round(zoomLevel * 100)}%
      </button>

      <button
        type="button"
        title="Zoom in"
        aria-label="Zoom in"
        className="yarl__button"
        style={{
          color: isMaxZoom ? 'gray' : color,
          backgroundColor: 'transparent',
          boxShadow: 'none',
          textShadow: 'none',
          filter: 'none',
          borderRadius: 0,
          cursor: isMaxZoom ? 'default' : 'pointer',
        }}
        onClick={() => zoomIn()}
        disabled={isMaxZoom}
      >
        <ZoomInIcon />
      </button>
    </div>
  );
};

const ImageZoomPan = ({ slide }: any) => {
  const theme = useTheme();

  return (
    <TransformWrapper
      key={slide.src}
      initialScale={1}
      minScale={1}
      maxScale={3}
      centerOnInit
      centerZoomedOut
      limitToBounds={true}
    >
      <ZoomControls color={theme.palette.text.secondary} />
      <TransformComponent
        wrapperStyle={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        contentStyle={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src={slide.src}
          alt={slide.alt || ''}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </TransformComponent>
    </TransformWrapper>
  );
};

export default ImageZoomPan;
